(function () {
  const ROOT_SEL = '#ateu-fspb';
  const TOTALS_SEL = '#CartDrawer .totals__total-value'; // drawer "Estimated total" amount

  function getThresholdCents() {
    const el = document.querySelector(ROOT_SEL);
    if (!el) return null;
    return Math.round(parseFloat(el.dataset.threshold || '45') * 100);
  }

  function toCentsFromMoneyString(str) {
    // Strip currency symbols, commas, spaces, letters (e.g., USD), keep digits and dot
    const clean = (str || '').replace(/[^0-9.]/g, '');
    const val = parseFloat(clean || '0');
    return Math.round(val * 100);
  }

  function render(subtotalCents) {
    const el = document.querySelector(ROOT_SEL);
    if (!el) return;
    const textEl = el.querySelector('.fspb__text');
    const fillEl = el.querySelector('.fspb__fill');
    const t = getThresholdCents();
    if (!textEl || !fillEl || t == null) return;

    const pct = Math.min(100, Math.round((subtotalCents / t) * 100));
    fillEl.style.width = pct + '%';

    if (subtotalCents >= t) {
      textEl.innerHTML = "🎉 <strong>FREE tracked shipping unlocked!</strong>";
    } else {
      const remaining = ((t - subtotalCents) / 100).toFixed(2);
      textEl.innerHTML =
        `✨ You're <strong>$${remaining}</strong> away from <strong>FREE tracked shipping ($45+)</strong> — add a lil something to unlock it!`;
    }
  }

  async function updateFromCartJs() {
    try {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      const res  = await fetch(root + 'cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      render(cart.items_subtotal_price || 0);
    } catch (_) { /* noop */ }
  }

  // Watch the visible drawer totals and re-render on any change
  function observeDrawerTotals() {
    const totalsEl = document.querySelector(TOTALS_SEL);
    if (!totalsEl) return;

    let lastText = totalsEl.textContent;
    // Initial render from DOM (fastest)
    render(toCentsFromMoneyString(lastText));

    const mo = new MutationObserver(() => {
      const txt = totalsEl.textContent;
      if (txt !== lastText) {
        lastText = txt;
        render(toCentsFromMoneyString(txt));
      }
    });
    mo.observe(totalsEl, { childList: true, characterData: true, subtree: true });
  }

  function burst() {
    // Use DOM totals immediately; also ask /cart.js shortly after to be extra sure
    observeDrawerTotals();
    setTimeout(updateFromCartJs, 50);
    setTimeout(updateFromCartJs, 300);
    setTimeout(updateFromCartJs, 900);
  }

  function attach() {
    // First pass
    burst();

    // Theme / Shopify events (when available)
    document.addEventListener('cart:updated', burst);
    document.addEventListener('cart:refresh', burst);
    document.addEventListener('shopify:section:load', burst);

    // Delegate +/–, remove, and qty input inside the drawer
    document.addEventListener('click', (e) => {
      if (e.target.closest('.quantity__button') || e.target.closest('cart-remove-button')) {
        burst();
      }
    });
    document.addEventListener('input', (e) => {
      if (e.target.matches('.quantity__input')) burst();
    });

    // Also react when the drawer opens/animates
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.addEventListener('transitionend', burst);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
